export default "__VITE_ASSET__CRxku0en__"